import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Text } from 'rebass';

type PageBarProps = {
  title: string;
  children?: React.ReactNode;
};

const PageBar = (props: PageBarProps): JSX.Element => (
  <Flex py={2} justifyContent="space-between" alignItems="center">
    <Flex>
      <Text variant="heading1">{props.title}</Text>
    </Flex>
    <Flex>{props.children}</Flex>
  </Flex>
);

PageBar.propTypes = {
  /**
   * Title string for the page bar
   */
  title: PropTypes.string.isRequired,
  /**
   * Any children meant to be rendered to the right side of the bar
   */
  children: PropTypes.node,
};

export default PageBar;
